import { render, staticRenderFns } from "./ItemGroupForm.vue?vue&type=template&id=28b1c73a&scoped=true"
import script from "./ItemGroupForm.vue?vue&type=script&lang=js"
export * from "./ItemGroupForm.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupForm.vue?vue&type=style&index=0&id=28b1c73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1c73a",
  null
  
)

export default component.exports